import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import OtpInput from "react-otp-input";
import {
  Button,
  Wrapper,
  Container,
  LogoWrapper,
  Heading,
  SubHeading,
  HelperText,
  Offer,
  Input,
  Divider,
  LinkButton,
  ShowPassword,
} from "./SignInOutForm.style";
import { AuthContext } from "../../contexts/auth/auth.context";
import { FormattedMessage } from "react-intl";
// import Image from 'components/Image/Image';
// import PickBazar from '../../image/PickBazar.png';
import { connect, useSelector } from "react-redux";
import { doPasswordChange, doPasswordRequest, resetmessages, doVerifyPasswordChange } from "../../store/actions/authAction";
import * as Constants from "../../constants/Constant";
import { OTPForm } from "./OTPform";
import Loader from "../../components/Loader/Loader";
import t from "../../i18n/translate"
import { Visibility, VisibilityOff } from "@material-ui/icons";

const ResetPassModal = (props) => {
  const { authDispatch, authState: { isAuthenticated } } = useContext(AuthContext);
  const [OTP, setOTP] = useState("");
  const [password, setPassword] = useState("");
  const [confPassword, setConfPassword] = useState("");
  const [regErr, setRegErr] = useState(false);
  const [valid, setValid] = useState(true);
  const [clock, setClock] = useState(60);
  const [alert, setAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);
  const cartType = useSelector(state => state.cartReducer.cartType);

  const toggleSignInForm = () => {
    authDispatch({
      type: "SIGNIN",
    });
  };
  const resetPassCallback = (e) => {
    e.preventDefault();

    if (!password) {
      setRegErr(true)
    }

    if (password !== confPassword || !confPassword) {
      setValid(false);
    }

    if (valid && !regErr && password && confPassword && password === confPassword) {
      props.doPasswordChange({
        identifier: props.email,
        password: password,
        otp: props.otp,
      });
    }
  };
  // useEffect(() => {
  //   return () => {
  //     props.resetmessages();
  //   }
  // },[]);

  useEffect(() => {
    if (props.success) {
      // authDispatch({ type: 'SIGNIN_SUCCESS' });
    }
  }, [props.success]);

  // Reset password success => go to success form
  useEffect(() => {
    let isCurrent = true;
    if (isCurrent && props.success && props.resetmessage.toLowerCase().includes("successfully")) {
      authDispatch({ type: 'SUCCESS' });
    }
    return () => isCurrent = false;
  }, [props.success, props.resetmessage]);

  const validateCreatePassword = () => {
    if (Constants.mediumRegex.test(password) === false) {
      setRegErr(true);
    } else {
      setRegErr(false);
    }

    if (confPassword && password !== confPassword) {
      setValid(false);
    } else {
      setValid(true)
    }
  }


  const validatePassword = async () => {
    console.log(valid);
    if (password === confPassword) {
      setValid(true);
    } else {
      setValid(false);
    }
  };

  const handleSubmitChangeOTP = async (otp) => {
    setOTP(otp);
    setAlert(false);
    let body = {
      identifier: props.email,
      key: props.otpKey,
      otp: otp,
    };
    if (otp.length === 6) {
      await props.doVerifyPasswordChange(body, setClock, setAlert, setAlertMsg);
    };
  };

  const handleResendOTP = (e, captcha) => {
    e.stopPropagation();
    setClock(60);
    setOTP("");
    setAlert(false);
    props.doPasswordRequest({ identifier: props.email, recaptchaToken: captcha });
  };

  return (
    <Wrapper>
      <Container style={{ overflow: "hidden", padding: "0px 40px 0" }}>
        {/* <LogoWrapper>
          <Image url={PickBazar} /> 
        </LogoWrapper> */}
        {
          props.showOtp ? 
            <OTPForm
              OTP={OTP}
              email={props.email}
              otpKey={props.otpKey}
              clock={clock}
              alert={alert}
              alertMsg={alertMsg}
              loading={props.loading}
              setAlert={setAlert}
              setClock={setClock}
              handleResendOTP={handleResendOTP}
              handleSubmitChangeOTP={handleSubmitChangeOTP}
            />
            :
            <>
              <Heading className={props.cartType}>
                {t("change_password_title")}
                {/* <FormattedMessage
                  id="signUpBtnText"
                  defaultMessage="Reset Password"
                /> */}
              </Heading>
               <form autoComplete="chrome-off" onSubmit={resetPassCallback}>
                {/* <FormattedMessage id="passwordPlaceholder" defaultMessage="Password">
                  {(placeholder) => ( */}
                    <label htmlFor="new-password" className="w-100 text-left text-muted mt-2"> {t('change_password_new_password_input_hint') }</label>
                    <div className="position-relative">
                      <Input
                        type={showPassword ? "text" : "password"}
                        id="new-password"
                        className={props.cartType}
                        placeholder={`${t('change_password_new_password_input_hint')}...`}
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                        }}
                        onBlur={validateCreatePassword}
                      />
                      <ShowPassword className={cartType} variant="outline-secondary" onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </ShowPassword>
                    </div>
                  {/* )}
                </FormattedMessage> */}

                {/* <FormattedMessage
                  id="confirmPasswordPlaceholder"
                  defaultMessage="Confirm Password"
                >
                  {(placeholder) => ( */}
                <label htmlFor="confirm-password" className="w-100 text-left text-muted mt-2">{ t('change_password_confirm_password_input_hint') }</label>
                    <div className="position-relative">
                      <Input
                        type={showCPassword ? "text" : "password"}
                        id="confirm-password"
                        className={props.cartType}
                        placeholder={`${t('change_password_confirm_password_input_hint')}...`}
                        value={confPassword}
                        onChange={(e) => {
                          setConfPassword(e.target.value);
                        }}
                        onBlur={validatePassword}
                      />
                      <ShowPassword className={cartType} variant="outline-secondary" onClick={() => setShowCPassword(!showCPassword)}>
                        {showCPassword ? <Visibility /> : <VisibilityOff />}
                      </ShowPassword>
                    </div>
                  {/* )}
                </FormattedMessage> */}
                {
                  regErr ? 
                    <span className="text-danger d-block mt-1">{t('change_password_error_password_format')}</span> 
                    : !valid ? <span className="text-danger d-block mt-1">{t('change_password_and_confirm_didnt_match')}</span> : null
                }

                <Button
                  fullwidth
                  type="submit"
                  title={t("change_password_continue_btn_title")}
                  intlButtonId="continueBtn"
                  style={{ color: "#fff", fontWeight: "normal", fontSize: '1rem', marginBottom: 30, marginTop: 150 }}
                  disabled={props.loading}
                  loader={<Loader />}
                  isLoading={props.loading}
                />
                {/* <span style={{color: "black", marginBottom: "10px"}} >Entered wrong email for reset password? <span onClick={(e) => {
                e.preventDefault();
                authDispatch({
                  type: "FORGOTPASS",
                });
                }} 
                style={{color: "green", textDecoration: "underline", fontWeight: "700", cursor: "pointer"}}>
                  Click here
                  </span>
                </span>
                <br/>
                <br/> */}
              </form>
            </>
        }
      </Container>
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.globalReducer.loading,
    success: state.authReducer.success,
    showOtp: state.authReducer.showOtp,
    email: state.authReducer.email,
    otpKey: state.authReducer.otpKey,
    otp: state.authReducer.otp,
    resetmessage: state.authReducer.resetmessage,
    cartType: state.cartReducer.cartType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    doPasswordChange: (body) => doPasswordChange(body, dispatch),
    doPasswordRequest: (body) => doPasswordRequest(body, dispatch),
    doVerifyPasswordChange: (body, setClock, setAlert, setAlertMsg) => doVerifyPasswordChange(body, setClock, setAlert, setAlertMsg, dispatch),
    resetmessages: () => resetmessages(dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ResetPassModal);
